import React from 'react';
import { useEffect, useState, useRef } from "react";
import NavButton from '../../homepage/header-banner/TopNavButton';
import styled from 'styled-components';
import Footer from '../../homepage/footer/Footer'
import Cloudconsult from '../../homepage/consult/cloudconsult';
import Banner from '../../container/Banner/Banner';
import {
    Container, Row, Col
} from 'react-bootstrap';
import { Grid } from '@mui/material';
import Titlecloudcompute from "../../container/Card/Components/Titlecloudcompute"
import Sidebar from '../../container/Sidebar/Sidebar'
import '../../container/Sidebar/sidebar.css'
import '../../Style/defaultstyle.css'
import '../../Style/defaultstyle.scss'
import CardWrap from '../../microservice/components/CardWrapper';
import CommonTable from '../../container/Table/Components/CommonTable';
import CloudConsultCp from '../../homepage/consult/cloudconsult-cp';
import '../../Style/typo.css'
import BanneServerApplication from '../../container/Banner/banner-serverApplication';
import DividerComponent from '../../container/Divider/divider';
import useIsMobile from '../../container/Sidebar/useIsMobile';
import BannerPrivateCloud from '../../container/Banner/banner-privateCloud';
import BannerPrivateCloudVN from '../../container/Banner/banner-privateCloud-vn';
import SidebarVN from '../../container/Sidebar/Sidebar-vn';
import HeaderVn from '../../detailpageVN/Page/component/headervn';
import FooterVn from '../../detailpageVN/Page/component/footervn';


const Sysfont = styled.div`
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen,
    Ubuntu, Cantarell, 'Open Sans', 'Helvetica Neue', sans-serif;
`;


// Titlecloudcompute
function MessagingServiceVN() {
    const isMobile = useIsMobile();
    useEffect(() => {
        document.title = 'Messaging Service - Serverless Application - Private Cloud';
    }, []);
    return (
        <Sysfont className='App'>
            <HeaderVn />
            <BannerPrivateCloudVN />
            <Container className="main-body">
                <Row>
                    <Col md={12} lg={3}>
                        {!isMobile && <SidebarVN />}
                    </Col>
                    <Col md={12} lg={9} className="right-content">
                        {/* {Titlecloudcompute("Messaging Service")} */}
                        <BoxContent>
                            <BoxText ><p class="typo-21-sm typo-medium typo-black">Sơ đồ cấu trúc Messaging</p></BoxText>
                            <ImageWrap src="https://hanbiro.com/assets/images/cloud/en/messaging-service-1.png"></ImageWrap>
                        </BoxContent>
                        <DividerComponent />
                        {/* {CardWrap("<p class='typo-21 typo-medium typo-black'>Messaging 구성도</p>", "", "", "https://hanbiro.com/cloud/library2/messaging-service/messaging-service-1.svg")} */}
                        <BoxContent>
                            <BoxTitle className='sub-title'><p class="typo-21 typo-medium typo-black">Sự khác biệt của Message Entity</p></BoxTitle>

                            <CommonTable
                                header={{
                                    row_1: [
                                        { title: "&nbsp;", },
                                        { title: "<p class='typo-14 typo-medium typo-white'>Topic</p>", },
                                        { title: "<p class='typo-14 typo-medium typo-white'>Queue</p>", },
                                        { title: "<p class='typo-14 typo-medium typo-white'>Channel</p>", },
                                    ],
                                }}
                                content={{
                                    row_1: [
                                        { title: "<p class='typo-14 typo-medium typo-black'>Delivery</p>", },
                                        {
                                            title: `<div style='text-align:center'>At Least Once (Exactly Once) <br>
                                            <p class='typo-14 purple-primary'>(Phương pháp Committing Offset)</p> 
                                            <img src='https://hanbiro.com/cloud/images/cloud/question.svg' width='20px'></img></div>`},
                                        {
                                            title: `<div style='text-align:center'>At Least Once (Exactly Once) <br> 
                                            <p class='typo-14 purple-primary'>(Phương pháp Ack Reply)</span> 
                                            <img src='https://hanbiro.com/cloud/images/cloud/question.svg' width='20px'></img></div>`},
                                        { title: "<div style='text-align:center'>At Most Once</div>", }
                                    ],
                                    row_2: [
                                        { title: "<p class='typo-14 typo-medium typo-black'>Storage</p>", },
                                        { title: "<p class='typo-14' style='text-align:center'>Disk</p>", },
                                        { title: "<p class='typo-14' style='text-align:center'>Disk</p>", },
                                        { title: "<p class='typo-14' style='text-align:center'>In Memory</p>", },
                                    ],
                                    row_3: [
                                        { title: "<p class='typo-14 typo-medium typo-black'>Ordering</p>", },
                                        { title: "<p class='typo-14' style='text-align:center'>Đảm bảo thứ tự</p>", },
                                        { title: "<p class='typo-14' style='text-align:center'>Không đảm bảo thứ tự</p>", },
                                        { title: "<p class='typo-14' style='text-align:center'>X</p>", },
                                    ],
                                    row_4: [
                                        { title: "<p class='typo-14 typo-medium typo-black'>Consumer</p>", },
                                        { title: "<p class='typo-14' style='text-align:center'>Pub / Sub</p>", },
                                        { title: "<p class='typo-14' style='text-align:center'>1:1</p>", },
                                        { title: "<p class='typo-14' style='text-align:center'>Fan Out (Broadcast)</p>", },
                                    ],
                                }} />
                            <BoxText><p class="typo-14 typo-medium purple-primary">• Phương pháp Committing Offset </p></BoxText>
                            <BoxSubText><p class="typo-14 purple-primary">Khi Consumer gọi Poll, nó sẽ cập nhật vị trí (Offset) của message mà nó đã lấy trên mỗi phân vùng (Commit)</p></BoxSubText>
                            <BoxText><p class="typo-14 typo-medium purple-primary">• Phương pháp Ack Reply</p></BoxText>
                            <BoxSubText><p class="typo-14 purple-primary">Sau khi Consumer hoặc Endpoint nhận message, gửi tín hiệu Ack và message đó sẽ bị xóa</p></BoxSubText>
                        </BoxContent>
                        <DividerComponent />
                        {CardWrap(
                            "Sự khác biệt giữa Pull và Push",

                            {
                                row_1: [
                                    { Cols50: "True", title: "<p class='typo-14 typo-medium typo-white'>Pull</p>" },
                                    { title: "<p class='typo-14 typo-medium typo-white'>Push</p>" },
                                ]
                            },

                            {
                                row_1: [
                                    {
                                        bold: "False", title: `<p class='typo-14'>Hỗ trợ Streaming Pull. </p>
                                                        <p class='typo-14'>Consumer gọi API để lấy Message.</p>`},
                                    { title: "<p class='typo-14'>Worker nhận message và gửi GRPC Unary hoặc yêu cầu GET/POST qua URL.</p>" }
                                ]
                            })}
                        <DividerComponent />
                        <BoxContent>
                            <BoxTitle className='sub-title'><p class="typo-21 typo-medium typo-black">Đặc điểm của Subscription</p></BoxTitle>
                            <BoxTextNone className='breakword'>
                                <p class="typo-14"><b>Message Entity (Topic / Queue / Channel)</b> có thể có nhiều <b>Subscription</b>(đăng ký),<br />
                                    nhưng một <b>Subscription</b> nhất định chỉ có thể liên kết với một <b>Message Entity</b> duy nhất.</p></BoxTextNone>
                            {/* {Imagecloudcompute("https://hanbiro.com/cloud/library2/messaging-service/messaging-service-2.svg")} */}
                            <ImageWrap src="https://hanbiro.com/assets/images/cloud/en/messaging-service-2.png"></ImageWrap>
                        </BoxContent>
                        {/*
                        {CardWrap("• Vora Desk Messaging Service 요약","","","https://hanbiro.com/cloud/library2/messaging-service/messaging-service-3.svg")}
                        */}

                        {/* <CloudConsultCp /> */}
                    </Col>
                </Row>
            </Container>

            <FooterVn />
        </Sysfont>
    );
};

const BoxSubText = styled.div`
  margin-left: 1.5%;
  color: #48A7FC;
`

const Box = styled.div`
  @media only screen and (max-width: 767px){
    font-size: 80%;
  }
`

const BoxContent = styled.div`
    ${'' /* box-shadow: 0 0.375rem 1.5rem 0 rgb(140 152 164 / 13%);
    border: 1px solid #E7EAF3;
    border-radius: 4px;
    margin-top: 20px;
    margin-bottom: 20px; */}
    text-align: left;
`

const BoxText = styled.div`
    margin: 5px;
    line-height: 2em;
    color: #48A7FC;
    font-weight: bold;
`

const BoxTextNone = styled.div`
    margin: 5px;
    line-height: 2em;
`

const BoxTitle = styled.div`
  text-align: left;
  font-weight: bold;
  font-size: 20px;
  margin-bottom: 20px;
`

const ImageWrap = styled.img`
  width: 100%;
  object-fit: fill;
`

export default MessagingServiceVN;
